import classNames from 'classnames'
import { TextInput, TextInputType } from '../../../TextInput'
import { singleSelectClasses } from '../componentClassNames'
import { useSingleSelectSearch, useSingleSelectState } from '../contexts'
import * as styles from './styles'

export const SearchBar: React.FC<{ className?: string }> = ({ className }) => {
  const {
    closeMenu,
    componentId,
    highlightedIndex,
    isOpen,
    onBlur,
    optionCount,
    setHighlightedIndex,
    toggleRef,
  } = useSingleSelectState()
  const { searchRef, setSearchTerm, setSearchFocused } = useSingleSelectSearch()

  const onSearchBlur = (e: React.FocusEvent) => {
    setSearchFocused(false)
    // If search loses focus, and search is still highlighted (index -1),
    // then focus was not given to the menu. Ergo, some outside element
    // gained focus, and we should close the menu
    // Ignore if relatedTarget is the toggle button, this happens when
    // you use ArrowDown to navigate to the menu items
    if (
      highlightedIndex === -1 &&
      e.relatedTarget !== toggleRef.current &&
      !searchRef?.current
    ) {
      onBlur?.()
      closeMenu()
    }
  }

  const onSearchKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      // The Escape is spent closing the menu; a containing panel or dialog
      // must not also close.
      e.stopPropagation()
      setTimeout(() => closeMenu(), 0)
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      if (optionCount === 0) return
      toggleRef.current?.focus()
      setHighlightedIndex(0)
    }
  }

  if (!isOpen) return null

  return (
    <div
      className={classNames(singleSelectClasses.search, className)}
      css={styles.searchContainer}
    >
      <TextInput
        ref={searchRef}
        htmlId={`${componentId}-search`}
        controlsHtmlId={`${componentId}-menu`}
        type={TextInputType.Search}
        additionalAriaLabels={{ 'aria-label': 'Search options list' }}
        clearable={true}
        leadingIconGlyph="gem-search"
        onChange={(val) => setSearchTerm(val)}
        onInputBlur={onSearchBlur}
        onKeyDown={onSearchKeyDown}
        placeholder=""
      />
    </div>
  )
}
SearchBar.displayName = 'Lapidary: SearchBar ← SingleSelect'
